import {
  BalanceAdjustment,
  BalanceAdjustmentPage,
} from "../../../domain/models/accounting/balance-adjustments.model";

type UnknownRecord = Record<string, unknown>;

const isRecord = (value: unknown): value is UnknownRecord =>
  typeof value === "object" && value !== null && !Array.isArray(value);

const isFiniteNumber = (value: unknown): value is number =>
  typeof value === "number" && Number.isFinite(value);

const isString = (value: unknown): value is string => typeof value === "string";

const isOptionalString = (value: unknown): value is string | null | undefined =>
  value === null || value === undefined || isString(value);

export function isBalanceAdjustment(value: unknown): value is BalanceAdjustment {
  return (
    isRecord(value) &&
    isFiniteNumber(value["idReconciliationBalanceAdjustment"]) &&
    isFiniteNumber(value["idCompany"]) &&
    isOptionalString(value["companyName"]) &&
    isFiniteNumber(value["idCurrency"]) &&
    isOptionalString(value["currencyCode"]) &&
    isFiniteNumber(value["amount"]) &&
    isString(value["reason"]) &&
    isFiniteNumber(value["idEmployee"]) &&
    isString(value["userName"]) &&
    isOptionalString(value["userRole"]) &&
    isString(value["status"]) &&
    isOptionalString(value["voucherReference"]) &&
    isString(value["createdAt"]) &&
    isOptionalString(value["updatedAt"])
  );
}

export function isBalanceAdjustmentPage(value: unknown): value is BalanceAdjustmentPage {
  return (
    isRecord(value) &&
    Array.isArray(value["items"]) &&
    value["items"].every(isBalanceAdjustment) &&
    isFiniteNumber(value["limit"]) &&
    isFiniteNumber(value["offset"]) &&
    typeof value["hasNext"] === "boolean"
  );
}
